import React, { useState, useEffect } from "react";

// Cinematic crossfading background slideshow with feathered corners that blend
// into the surrounding scene. Images fade in/out; dark gradient + vignette keep text legible.
export const HeroSlideshow = ({ images = [], interval = 5000 }) => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (images.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % images.length), interval);
    return () => clearInterval(t);
  }, [images.length, interval]);

  const featherMask = "radial-gradient(120% 130% at 60% 40%, #000 45%, rgba(0,0,0,0.55) 72%, rgba(0,0,0,0) 100%)";

  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
      {images.map((src, i) => (
        <div
          key={src}
          className="absolute inset-0 transition-opacity duration-[1600ms] ease-in-out"
          style={{ opacity: i === idx ? 1 : 0 }}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url(${src})`,
              WebkitMaskImage: featherMask,
              maskImage: featherMask,
              transform: i === idx ? "scale(1.06)" : "scale(1.0)",
              transition: "transform 6000ms ease-out",
            }}
          />
        </div>
      ))}
      {/* Blend + contrast layers so it melts into the navy scene */}
      <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, #0B102B 0%, rgba(11,16,43,0.82) 38%, rgba(11,16,43,0.35) 70%, rgba(11,16,43,0.7) 100%)" }} />
      <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom, #0B102B 0%, rgba(11,16,43,0) 22%, rgba(11,16,43,0) 60%, #0B102B 100%)" }} />
      <div className="absolute inset-0" style={{ background: "radial-gradient(80% 60% at 78% 30%, rgba(124,58,237,0.28) 0%, rgba(6,182,212,0.10) 40%, rgba(0,0,0,0) 70%)" }} />
    </div>
  );
};
